module.exports = __webpack_public_path__ + "img/conference_room.3207ab2b.png";